module.exports = __webpack_public_path__ + "img/partner_00_nassmagnet.9120b212.png";